import { render, staticRenderFns } from "./Omikuji.vue?vue&type=template&id=e2f9e724&scoped=true"
import script from "./Omikuji.vue?vue&type=script&lang=js"
export * from "./Omikuji.vue?vue&type=script&lang=js"
import style0 from "./Omikuji.vue?vue&type=style&index=0&id=e2f9e724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9e724",
  null
  
)

export default component.exports